import { render, staticRenderFns } from "./ConferenceOverview.vue?vue&type=template&id=1dbb6690"
import script from "./ConferenceOverview.vue?vue&type=script&lang=js"
export * from "./ConferenceOverview.vue?vue&type=script&lang=js"
import style0 from "./ConferenceOverview.vue?vue&type=style&index=0&id=1dbb6690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports